module.exports = __webpack_public_path__ + "img/produkttraining_784x514.fb18f2ff.jpg";